// @flow

import './gilroy.css';

import { createGlobalStyle } from 'styled-components';
import { theme } from '../theme';

export const GlobalStyle = createGlobalStyle`
  html, body, #tectonics {
    font-size: 14px;
    font-family: ${theme.fontFamily.sansSerif};
    color: ${theme.colors.black(40)};
    background-color: ${theme.colors.gray(96)};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    color: inherit;
  }

  h2 {
    font-weight: 500;
    font-size: 1.4em;
  }

  strong {
    font-weight: 700;
  }

  small {
    font-size: 0.7em;
  }
`;
